(function() {
  var $ba793e2bb1b65094$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("blog-nav")) customElements.define("blog-nav", class BlogNav extends HTMLElement {
      constructor() {
        super();
        this.links = [];
        this.observer = null;
        this.boundHandleScroll = this.handleScroll.bind(this);
      }
      connectedCallback() {
        this.links = [ ...this.querySelectorAll('a[href^="#"]') ];
        if (this.links.length === 0) return;
        this.initObserver();
        window.addEventListener("scroll", this.boundHandleScroll, {
          passive: true
        });
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener("scroll", this.boundHandleScroll);
      }
      initObserver() {
        const rawHeaderHeight = getComputedStyle(document.documentElement).getPropertyValue("--header-full-height");
        const headerHeight = rawHeaderHeight.trim() || "76px";
        const options = {
          rootMargin: `-${headerHeight} 0px -70% 0px`,
          threshold: 0
        };
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) this.highlightLink(entry.target.id);
          });
        }, options);
        this.links.forEach(link => {
          const id = link.getAttribute("href").substring(1);
          const target = document.getElementById(id);
          if (target) this.observer.observe(target);
        });
      }
      highlightLink(id) {
        this.links.forEach(link => {
          const href = link.getAttribute("href").substring(1);
          if (href === id) {
            link.classList.add("text-scheme-links", "border-scheme-links");
            link.classList.remove("text-scheme-text", "border-transparent");
            link.parentElement.scrollTo({
              left: link.offsetLeft + link.offsetWidth / 2 - link.parentElement.offsetWidth / 2,
              behavior: "smooth"
            });
          } else {
            link.classList.remove("text-scheme-links", "border-scheme-links");
            link.classList.add("text-scheme-text", "border-transparent");
          }
        });
      }
      handleScroll() {
        if (window.scrollY < 100) this.highlightLink(this.links[0].getAttribute("href").substring(1));
      }
    });
  })();
})();